var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useQuery } from '@apollo/client';
import { GET_WEB_API_CLIENTS } from './query';
export function useApiKeys() {
    const { data, loading, error } = useQuery(GET_WEB_API_CLIENTS);
    const apiKeys = data === null || data === void 0 ? void 0 : data.webApiClients.map(apiKey => {
        const { createdByCompanyUser } = apiKey, rest = __rest(apiKey, ["createdByCompanyUser"]);
        const { name: userName = '' } = (createdByCompanyUser === null || createdByCompanyUser === void 0 ? void 0 : createdByCompanyUser.user) || {};
        return Object.assign(Object.assign({}, rest), { userName });
    });
    return { apiKeys: apiKeys || [], loading, error };
}
